import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-badge.css';
import { v as validatePropType } from '../validate-prop-types/index-chunk.esm.js';

const EGDSBadgeSize = {
    SMALL: 'small',
    LARGE: 'large',
};
const EGDSBadgeStandardThemes = {
    STANDARD: 'standard',
    EMPHASIS: 'emphasis',
    INFO: 'info',
    FEATURED: 'featured',
    BRAND: 'brand',
    WARNING: 'warning',
    POSITIVE: 'positive',
};
const EGDSBadgeLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    EXTRAHIGH: 'extrahightier',
    GLOBAL_STANDARD: 'global-standardtier',
    GLOBAL_LOW: 'global-lowtier',
    GLOBAL_MIDDLE: 'global-middletier',
    GLOBAL_HIGH: 'global-hightier',
    GLOBAL_EXTRAHIGH: 'global-extrahightier',
    VIP: 'vip',
};
const EGDSBadgeProgramThemes = {
    DEAL: 'deal',
    MEMBER: 'member',
    TRIP_SAVINGS: 'trip',
    SUPPLIER_PROMO: 'supplierpromo',
    VIRTUAL_MARKET_COACH: 'vmc',
};
const EGDSBadgeNotificationThemes = {
    UNREAD: 'unread',
    ACTIVITY: 'activity',
    ACTION: 'action',
    DEFAULT: 'default',
    INVERSE: 'inverse',
};

const getClassNameList$6 = classNames.bind(styles);
/**
 * @deprecated EGDSBadge and EGDSBadgeTheme should not be used. Use one themes from the specific badge type from the specific badge types instead like `EGDSBadgeStandardTheme`
 */
var EGDSBadgeTheme;
(function (EGDSBadgeTheme) {
    EGDSBadgeTheme["DEAL_BUNDLED"] = "deal-bundled";
    EGDSBadgeTheme["DEAL_GENERIC"] = "deal-generic";
    EGDSBadgeTheme["DEAL_MEMBER"] = "deal-member";
    EGDSBadgeTheme["NOTIFICATION_1"] = "notification-1";
    EGDSBadgeTheme["NOTIFICATION_2"] = "notification-2";
    EGDSBadgeTheme["VIP"] = "vip";
    EGDSBadgeTheme["LOYALTY_EXTRA_HIGH_TIER"] = "loyalty-extra-high-tier";
    EGDSBadgeTheme["LOYALTY_HIGH_TIER"] = "loyalty-high-tier";
    EGDSBadgeTheme["LOYALTY_MIDDLE_TIER"] = "loyalty-middle-tier";
    EGDSBadgeTheme["LOYALTY_LOW_TIER"] = "loyalty-low-tier";
    EGDSBadgeTheme["SPONSORED"] = "sponsored";
    EGDSBadgeTheme["PROMOTED"] = "promoted";
    EGDSBadgeTheme["VIEWED"] = "viewed";
    EGDSBadgeTheme["SAVED"] = "saved";
    EGDSBadgeTheme["FAMILY_FRIENDLY"] = "family-friendly";
    EGDSBadgeTheme["SUPPLIER_PROMO"] = "supplier-promo";
})(EGDSBadgeTheme || (EGDSBadgeTheme = {}));
/**
 * @deprecated do not use. Use one of the specific badge types instead `EGDSBadgeStandard, EGDSBadgeLoyalty, EGDSBadgeNotification, EGDSBadgeProgram`
 */
class EGDSBadge extends React.Component {
    static displayName = 'EGDSBadge';
    static defaultProps = {
        size: EGDSBadgeSize.LARGE,
        theme: EGDSBadgeTheme.DEAL_GENERIC,
    };
    static baseClassName = 'uitk-badge';
    render() {
        const { a11yText, className, children, text, size, theme } = this.props;
        const wrapperClassNames = getClassNameList$6('uitk-badge', {
            [`${EGDSBadge.baseClassName}-${size}`]: validatePropType(size, EGDSBadgeSize),
        }, {
            [`${EGDSBadge.baseClassName}-${theme}`]: validatePropType(theme, EGDSBadgeTheme),
        }, {
            [`${EGDSBadge.baseClassName}-has-text`]: text,
        }, className);
        return (jsxs("span", { className: wrapperClassNames, children: [children, text && (jsx("span", { className: getClassNameList$6(`${EGDSBadge.baseClassName}-text`), "aria-hidden": !!a11yText, children: text })), a11yText && jsx("span", { className: "is-visually-hidden", children: a11yText })] }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSDealBundledBadge extends React.PureComponent {
    static displayName = 'EGDSDealBundledBadge';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return (jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.LARGE, theme: EGDSBadgeTheme.DEAL_BUNDLED, className: cssClassNames }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSDealGenericBadge extends React.PureComponent {
    static displayName = 'EGDSDealGenericBadge';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return (jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.LARGE, theme: EGDSBadgeTheme.DEAL_GENERIC, className: cssClassNames }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSDealMemberBadge extends React.PureComponent {
    static displayName = 'EGDSDealMemberBadge';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return (jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.LARGE, theme: EGDSBadgeTheme.DEAL_MEMBER, className: cssClassNames }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSSavedBadge extends React.PureComponent {
    static displayName = 'EGDSSavedBadge';
    render() {
        const { props } = this;
        const cssClassNames = classNames(props.className);
        const badgeProps = {
            className: cssClassNames,
            size: EGDSBadgeSize.SMALL,
            theme: EGDSBadgeTheme.SAVED,
            ...props,
        };
        return jsx(EGDSBadge, { ...badgeProps });
    }
}

/**
 * @deprecated do not use. Use one of the specific badge types instead `EGDSBadgeStandard, EGDSBadgeLoyalty, EGDSBadgeNotification, EGDSBadgeProgram`
 */
class EGDSSponsoredBadge extends React.PureComponent {
    static displayName = 'EGDSSponsoredBadge';
    render() {
        const { className, hasBorder } = this.props;
        const cssClassNames = classNames(className, {
            [`${EGDSBadge.baseClassName}-has-border`]: hasBorder,
        });
        return (jsx(EGDSBadge, { ...this.props, size: EGDSBadgeSize.SMALL, theme: EGDSBadgeTheme.PROMOTED, className: cssClassNames }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSViewedBadge extends React.PureComponent {
    static displayName = 'EGDSViewedBadge';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.SMALL, theme: EGDSBadgeTheme.VIEWED, className: cssClassNames });
    }
}

/**
 * @deprecated do not use
 */
class EGDSVipBadge extends React.PureComponent {
    static displayName = 'EGDSVipBadge';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.LARGE, theme: EGDSBadgeTheme.VIP, className: cssClassNames });
    }
}

/**
 * @deprecated do not use
 */
class EGDSNotificationBadge1 extends React.PureComponent {
    static displayName = 'EGDSNotificationBadge1';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return (jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.SMALL, theme: EGDSBadgeTheme.NOTIFICATION_1, className: cssClassNames }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSNotificationBadge2 extends React.PureComponent {
    static displayName = 'EGDSNotificationBadge2';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return (jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.SMALL, theme: EGDSBadgeTheme.NOTIFICATION_2, className: cssClassNames }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSFamilyFriendlyBadge extends React.PureComponent {
    static displayName = 'EGDSFamilyFriendlyBadge';
    render() {
        const { props } = this;
        const cssClassNames = classNames(props.className);
        const badgeProps = {
            className: cssClassNames,
            size: EGDSBadgeSize.LARGE,
            theme: EGDSBadgeTheme.FAMILY_FRIENDLY,
            ...props,
        };
        return jsx(EGDSBadge, { ...badgeProps });
    }
}

/**
 * @deprecated do not use
 */
class EGDSSupplierPromoBadge extends React.PureComponent {
    static displayName = 'EGDSSupplierPromoBadge';
    render() {
        const { className, ...props } = this.props;
        const cssClassNames = classNames(className);
        return (jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.LARGE, theme: EGDSBadgeTheme.SUPPLIER_PROMO, className: cssClassNames }));
    }
}

/**
 * @deprecated do not use
 */
class EGDSMemberBadge extends React.PureComponent {
    static displayName = 'EGDSMemberBadge';
    render() {
        const { className, theme, ...props } = this.props;
        const cssClassNames = classNames(className);
        return jsx(EGDSBadge, { ...props, size: EGDSBadgeSize.LARGE, theme: theme, className: cssClassNames });
    }
}

const getClassNameList$5 = classNames.bind(styles);
/**
 * @deprecated do not use
 */
const EGDSFloatingDotNotificationBadge = (props) => {
    const { className, visible } = props;
    const baseClassName = 'uitk-badge-floating-dot-notification';
    const wrapperClassNames = getClassNameList$5(baseClassName, visible && `${baseClassName}-is-visible`, className);
    return jsx("div", { className: wrapperClassNames });
};
EGDSFloatingDotNotificationBadge.defaultProps = {
    visible: true,
};
EGDSFloatingDotNotificationBadge.displayName = 'EGDSFloatingDotNotificationBadge';

const getClassNameList$4 = classNames.bind(styles);
/**
 * @deprecated do not use. Use one of the specific badge types instead `EGDSBadgeStandard, EGDSBadgeLoyalty, EGDSBadgeNotification, EGDSBadgeProgram`
 */
const EGDSDotNotificationBadge = (props) => {
    const { className, visible } = props;
    const baseClassName = 'uitk-badge-dot-notification';
    const wrapperClassNames = getClassNameList$4(baseClassName, visible && `${baseClassName}-is-visible`, className);
    return jsx("div", { className: wrapperClassNames });
};
EGDSDotNotificationBadge.defaultProps = {
    visible: true,
};
EGDSDotNotificationBadge.displayName = 'EGDSDotNotificationBadge';

const getClassNameList$3 = classNames.bind(styles);
const EGDSBadgeStandard = (props) => {
    const { text, size, theme, a11yText, className, children } = props;
    const sharedCssClassName = 'uitk-badge-base';
    const baseCssClassName = 'uitk-badge';
    const hasTextAsChild = React.Children.toArray(children).some((child) => typeof child === 'string');
    const standardBadgeClassNames = getClassNameList$3(baseCssClassName, `${sharedCssClassName}-${validatePropType(size, EGDSBadgeSize) ? size : EGDSBadgeSize.LARGE}`, { [`${sharedCssClassName}-has-text`]: text }, { [`${sharedCssClassName}-icon-only`]: !text && children && !hasTextAsChild }, `${baseCssClassName}-${validatePropType(theme, EGDSBadgeStandardThemes) ? theme : EGDSBadgeStandardThemes.STANDARD}`, className);
    return (jsxs("span", { className: standardBadgeClassNames, children: [children, text && (jsx("span", { className: getClassNameList$3(`${sharedCssClassName}-text`), "aria-hidden": !!a11yText, children: text })), a11yText && jsx("span", { className: getClassNameList$3('is-visually-hidden'), children: a11yText })] }));
};
EGDSBadgeStandard.displayName = 'EGDSBadgeStandard';

const getClassNameList$2 = classNames.bind(styles);
const EGDSBadgeNotification = (props) => {
    const { count, theme, visible, a11yText, className, children } = props;
    const baseCssClassName = 'uitk-badge';
    const notificationCssClassName = 'uitk-badge-notification';
    const hasCount = typeof count === 'string';
    let withIcon = false;
    React.Children.forEach(children, (child) => {
        if (child.type?.displayName?.match(/(EGDS|Uitk)Icon/)) {
            withIcon = true;
        }
    });
    const standardBadgeClassNames = getClassNameList$2(baseCssClassName, hasCount ? `${notificationCssClassName}-count` : `${notificationCssClassName}-dot`, withIcon ? `${notificationCssClassName}-with-icon` : `${notificationCssClassName}-with-text`, `${notificationCssClassName}-${validatePropType(theme, EGDSBadgeNotificationThemes) ? theme : EGDSBadgeNotificationThemes.DEFAULT}`, className);
    return visible ? (jsxs("span", { className: getClassNameList$2(`${notificationCssClassName}-wrapper`), children: [withIcon ? (jsx("span", { className: getClassNameList$2(`${notificationCssClassName}-${hasCount ? 'count-mask' : 'dot-mask'}`), children: children })) : (jsx(Fragment, { children: children })), jsxs("span", { className: standardBadgeClassNames, "aria-hidden": !!a11yText, children: [hasCount && (jsx("span", { className: getClassNameList$2(`${notificationCssClassName}-numbers`), children: Number(count) > 99 ? '99+' : count })), a11yText && jsx("span", { className: getClassNameList$2('is-visually-hidden'), children: a11yText })] })] })) : (jsx(Fragment, { children: children }));
};
EGDSBadgeNotification.displayName = 'EGDSBadgeNotification';

const getClassNameList$1 = classNames.bind(styles);
const EGDSBadgeLoyalty = (props) => {
    const { text, size, theme, children, a11yText, className } = props;
    const sharedCssClassName = 'uitk-badge-base';
    const baseCssClassName = 'uitk-badge';
    const loyaltyCssClassName = `${baseCssClassName}-loyalty`;
    const loyaltyBadgeClassNames = getClassNameList$1(sharedCssClassName, `${sharedCssClassName}-${validatePropType(size, EGDSBadgeSize) ? size : EGDSBadgeSize.LARGE}`, { [`${sharedCssClassName}-has-text`]: text }, `${loyaltyCssClassName}-${validatePropType(theme, EGDSBadgeLoyaltyThemes) ? theme : EGDSBadgeLoyaltyThemes.LOW}`, className);
    return (jsxs("span", { className: loyaltyBadgeClassNames, children: [children, text && (jsx("span", { className: getClassNameList$1(`${sharedCssClassName}-text`), "aria-hidden": !!a11yText, children: text })), a11yText && jsx("span", { className: getClassNameList$1('is-visually-hidden'), children: a11yText })] }));
};
EGDSBadgeLoyalty.displayName = 'EGDSBadgeLoyalty';

const getClassNameList = classNames.bind(styles);
const EGDSBadgeProgram = (props) => {
    const { text, theme, a11yText, className, children } = props;
    const sharedCssClassName = 'uitk-badge-base';
    const baseCssClassName = 'uitk-badge';
    const programCssClassName = `${baseCssClassName}-program`;
    const hasTextAsChild = React.Children.toArray(children).some((child) => typeof child === 'string');
    const standardBadgeClassNames = getClassNameList(sharedCssClassName, `${sharedCssClassName}-large`, { [`${sharedCssClassName}-has-text`]: text }, { [`${sharedCssClassName}-icon-only`]: !text && children && !hasTextAsChild }, `${programCssClassName}-${validatePropType(theme, EGDSBadgeProgramThemes) && theme}`, className);
    return (jsxs("span", { className: standardBadgeClassNames, children: [children, text && (jsx("span", { className: getClassNameList(`${sharedCssClassName}-text`), "aria-hidden": !!a11yText, children: text })), a11yText && jsx("span", { className: getClassNameList('is-visually-hidden'), children: a11yText })] }));
};
EGDSBadgeProgram.displayName = 'EGDSBadgeProgram';

export { EGDSBadgeTheme as E, EGDSBadge as a, EGDSDealBundledBadge as b, EGDSDealGenericBadge as c, EGDSDealMemberBadge as d, EGDSSavedBadge as e, EGDSSponsoredBadge as f, EGDSViewedBadge as g, EGDSVipBadge as h, EGDSNotificationBadge1 as i, EGDSNotificationBadge2 as j, EGDSFamilyFriendlyBadge as k, EGDSSupplierPromoBadge as l, EGDSMemberBadge as m, EGDSFloatingDotNotificationBadge as n, EGDSDotNotificationBadge as o, EGDSBadgeStandard as p, EGDSBadgeNotification as q, EGDSBadgeLoyalty as r, EGDSBadgeProgram as s, EGDSBadgeSize as t, EGDSBadgeStandardThemes as u, EGDSBadgeLoyaltyThemes as v, EGDSBadgeProgramThemes as w, EGDSBadgeNotificationThemes as x };
//# sourceMappingURL=index-chunk.esm.js.map
